import '../../styles.scss';
import { init } from './app';

init();
